module.exports = __webpack_public_path__ + "img/fd12fb10.prt.e23ce794.jpg";